export default "__VITE_ASSET__YUc5C5o8__"